'use client';

// localStorage is an external store, so it's read through useSyncExternalStore
// rather than an effect: that keeps the server render and the hydration pass
// consistent (server sees no token), and avoids setting state during an effect.
//
// Subscribing to `storage` events is a small bonus — unlocking or locking in one
// tab now takes effect in every other tab of the same browser.

const KEY = 'console.token';

const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  // Fired by *other* tabs; same-tab writes go through emit() below.
  window.addEventListener('storage', onChange);
  return () => {
    listeners.delete(onChange);
    window.removeEventListener('storage', onChange);
  };
}

export function getSnapshot(): string | null {
  return localStorage.getItem(KEY);
}

/** No token exists during SSR, so the gate is what renders on the server. */
export function getServerSnapshot(): string | null {
  return null;
}

export function storeToken(token: string): void {
  localStorage.setItem(KEY, token);
  emit();
}

export function clearToken(): void {
  localStorage.removeItem(KEY);
  emit();
}
